class FreeGiftManager {
  constructor() {
    this.settings = {
      enabled: window.theme?.settings?.enable_free_gift || false,
      threshold: parseFloat(window.theme?.settings?.free_gift_threshold) || 100,
      productId: window.theme?.settings?.free_gift_product || null,
      variant_id: window.theme?.settings?.free_gift_variant || null,
    };
    
    this.giftProperty = '_free_gift';
  }

  async processGift() {
    try {
      const cart = await this.getCart();
      const hasGift = this.hasGiftInCart(cart);

      // 🚨 Remove gift immediately if free gift feature is disabled
      if (!this.settings.enabled) {
        if (hasGift) {
          await this.removeGiftFromCart(cart);
        }
        return;
      }

      if (!this.settings.variant_id) return;

      const cartTotal = this.calculateCartTotal(cart);

      if (cartTotal >= this.settings.threshold && !hasGift) {
        await this.addGiftToCart();
      } else if (cartTotal < this.settings.threshold && hasGift) {
        await this.removeGiftFromCart(cart);
      }

      if (cart.total_price == 0) {
        const cartCount = document.querySelector('.cart-link__count');
        if (cartCount) {
          cartCount.innerHTML = '';
        }
      }
    } catch (error) {
      console.error('Error processing free gift:', error);
    }
  }


  async getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  calculateCartTotal(cart) {
    return cart.items.reduce((total, item) => {
      // Exclude free gift items from total calculation
      if (item.properties && item.properties[this.giftProperty]) {
        return total;
      }
      return total + item.line_price;
    }, 0) / 100; // Convert from cents to currency units
  }

  hasGiftInCart(cart) {
    return cart.items.some(item => 
      item.variant_id === this.settings.variant_id && 
      item.properties && 
      item.properties[this.giftProperty]
    );
  }

  async addGiftToCart() {
    const payload = {
      items: [{
        id: this.settings.variant_id,
        quantity: 1,
        properties: {
          [this.giftProperty]: 'true'
        }
      }]
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Failed to add gift: ${response.status}`);
      }
    } catch (error) {
      console.error('Error adding gift to cart:', error);
    }
  }

  async removeGiftFromCart(cart) {
    const giftItems = cart.items.filter(item => 
      item.variant_id === this.settings.variant_id && 
      item.properties && 
      item.properties[this.giftProperty]
    );

    for (const giftItem of giftItems) {
      try {
        const payload = {
          id: giftItem.key,
          quantity: 0
        };

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`Failed to remove gift: ${response.status}`);
        }
      } catch (error) {
        console.error('Error removing gift from cart:', error);
      }
    }
  }
}

// Initialize the free gift manager
const freeGiftManager = new FreeGiftManager();

// Function to be called after cart refresh
function handleCartRefresh() {
  if (freeGiftManager.settings.enabled) {
    freeGiftManager.processGift();
  }
}

(async () => {
  await freeGiftManager.processGift();
})();